function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 10H20C20 11.86 18.72 13.41 17 13.86V15H20C20 16.86 18.72 18.41 17 18.86V20C17 20.55 16.55 21 16 21H8C7.45 21 7 20.55 7 20V18.86C5.28 18.41 4 16.86 4 15H7V13.86C5.28 13.41 4 11.86 4 10H7V8.86C5.28 8.41 4 6.86 4 5H7V4C7 3.45 7.45 3 8 3H16C16.55 3 17 3.45 17 4V5H20C20 6.86 18.72 8.41 17 8.86V10ZM10 17C10 18.1 10.89 19 12 19C13.11 19 14 18.1 14 17C14 15.9 13.1 15 12 15C10.89 15 10 15.9 10 17ZM12 14C10.89 14 10 13.1 10 12C10 10.9 10.89 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.11 14 12 14ZM10 7C10 8.1 10.89 9 12 9C13.11 9 14 8.1 14 7C14 5.89 13.1 5 12 5C10.89 5 10 5.89 10 7Z",
  fill: "#979797"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  maskType: "alpha",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 3,
  width: 16,
  height: 18
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 10H20C20 11.86 18.72 13.41 17 13.86V15H20C20 16.86 18.72 18.41 17 18.86V20C17 20.55 16.55 21 16 21H8C7.45 21 7 20.55 7 20V18.86C5.28 18.41 4 16.86 4 15H7V13.86C5.28 13.41 4 11.86 4 10H7V8.86C5.28 8.41 4 6.86 4 5H7V4C7 3.45 7.45 3 8 3H16C16.55 3 17 3.45 17 4V5H20C20 6.86 18.72 8.41 17 8.86V10ZM10 17C10 18.1 10.89 19 12 19C13.11 19 14 18.1 14 17C14 15.9 13.1 15 12 15C10.89 15 10 15.9 10 17ZM12 14C10.89 14 10 13.1 10 12C10 10.9 10.89 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.11 14 12 14ZM10 7C10 8.1 10.89 9 12 9C13.11 9 14 8.1 14 7C14 5.89 13.1 5 12 5C10.89 5 10 5.89 10 7Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#979797"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/traffic-light.acb9fd20.svg";
export { SvgComponent as ReactComponent };